import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {AmaronEventTypes} from "./Events";

export enum AmaronEventContainerTypes {
    Journeys = "46724239-4aa2-4f10-8887-4f747f7c137f",
}

export const amaronEventContainerTypeByEventType: Record<AmaronEventTypes, AmaronEventContainerTypes> = {
    [AmaronEventTypes.Enquiry]: AmaronEventContainerTypes.Journeys,
    [AmaronEventTypes.Calls]: AmaronEventContainerTypes.Journeys,
    [AmaronEventTypes.Service]: AmaronEventContainerTypes.Journeys,
};

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const AMARON__EVENT_CONTAINER__LEADS__DISPOSITION__COLUMN_ID = "74f4559d-dafa-44c7-af3a-965c86d0648b" as Uuid;

export const AMARON__EVENT_CONTAINER__LEADS__ORGANIZATIONAL_UNIT__COLUMN_ID = "6da5eb8d-adba-4963-ba12-6d8063169277" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID = "3855feb2-74ed-49d1-9754-ae6aa869a71c" as Uuid;

export const AMARON__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID = "a26da2fc-cd72-4ce2-b06a-060c05ad821f" as Uuid;

export const AMARON__EVENT_CONTAINER__SMARTPING_CAMPAIGN__COLUMN_ID = "51081533-105d-4326-9eb8-9fdba1ba367b" as Uuid;

export const AMARON__EVENT_CONTAINER__LEAD_STATUS__COLUMN_ID = "199f8f25-e6a5-4118-9902-9b158283c7e4" as Uuid;

export const AMARON__EVENT_CONTAINER__DISPOSITION__COLUMN_ID = "cc4a944e-2625-4bb5-97c4-c8f949d66ba6" as Uuid;

export const AMARON__EVENT_CONTAINER__L1_DISPOSITION__COLUMN_ID = "f1a82b3c-9d4e-4a5b-8c7d-6e5f4a3b2c1d" as Uuid;

export const AMARON__EVENT_CONTAINER__L2_DISPOSITION__COLUMN_ID = "e2b93c4d-0e5f-4b6c-9d8e-7f6a5b4c3d2e" as Uuid;

export const AMARON__EVENT_CONTAINER__L3_DISPOSITION__COLUMN_ID = "9bb6d849-3148-4a47-8b35-0270b07243af" as Uuid;

export const AMARON__EVENT_CONTAINER__L4_DISPOSITION__COLUMN_ID = "b4e15f70-3a8c-4f9e-b1d0-8a9c8d7e6f5a" as Uuid;

export const AMARON__EVENT_CONTAINER__REMARKS__COLUMN_ID = "12c16da4-0ef7-41de-bec2-e6d2b5ffdeaf" as Uuid;

export const AMARON__EVENT_CONTAINER__SOURCE__PRIORITY__COLUMN_ID = "caf47af1-edfa-46d5-a257-8e436a1efee5" as Uuid;

export const AMARON__EVENT_CONTAINER__AON__COLUMN_ID = "8537eb54-2eb2-49eb-b769-55843c591054" as Uuid;

export const AMARON__EVENT_CONTAINER__ASSIGNED_TO__COLUMN_ID = "5d5d7dad-e071-4269-8da9-8bf98354cd46" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_HOUSE_NO__COLUMN_ID = "606393fb-c981-4a79-ba7c-6c819be8513b" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_STATE__COLUMN_ID = "0796a534-0337-4c9f-8d0b-74099bcb3700" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_CITY__COLUMN_ID = "d328973b-c577-4231-afe6-ec4fe776d0a4" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_VOC__COLUMN_ID = "73bc375f-86c7-4a9e-8342-d80cdb7d72d8" as Uuid;

export const AMARON__EVENT_CONTAINER__FUEL_TYPE__COLUMN_ID = "8813fc82-5dd1-4ce4-b026-255988e87825" as Uuid;

export const AMARON__EVENT_CONTAINER__AD_NAME__COLUMN_ID = "21fabd59-565d-4820-a307-e44ffa5ccd1e" as Uuid;

export const AMARON__EVENT_CONTAINER__AD_SET_NAME__COLUMN_ID = "8aa98e85-aa43-4ab2-8327-18501eb2b7e0" as Uuid;

export const AMARON__EVENT_CONTAINER__SERVICE_REQUESTED__COLUMN_ID = "138b9f03-f0ce-4d7b-b0fb-71a1dee2fe26" as Uuid;

export const AMARON__EVENT_CONTAINER__CAR_MAKE__COLUMN_ID = "29bd1de9-dbe5-4423-a921-631ba99bec2c" as Uuid;

export const AMARON__EVENT_CONTAINER__CAR_MODEL__COLUMN_ID = "060675ca-cc62-43cc-b7f2-85a4a2cfa48d" as Uuid;

export const AMARON__EVENT_CONTAINER__WHATSAPP_CONSENT__COLUMN_ID = "586550c0-b8a1-4411-9645-9f19165027c2" as Uuid;

export const AMARON__EVENT_CONTAINER__TERMS_PRIVACY_CONSENT__COLUMN_ID = "27bfd8e8-0cd1-4e76-aa1e-de09b72b78c3" as Uuid;

export const AMARON__EVENT_CONTAINER__INQUEUE_STATUS__COLUMN_ID = "436ee25f-13cf-4118-b21d-c466db11ee74" as Uuid;

export const AMARON__EVENT_CONTAINER__SCHEDULED_CALL_DATE__COLUMN_ID = "16df8037-9319-427d-abd9-2a0cd336aacd" as Uuid;

export const AMARON__EVENT_CONTAINER__SCHEDULED_CALL_TIME__COLUMN_ID = "bc7ab147-047e-4257-862d-4ac43adefbd3" as Uuid;

export const AMARON__EVENT_CONTAINER__ENQUIRIES_COUNT__COLUMN_ID = "804fda29-9bd3-4b0e-8890-587401e9743d" as Uuid;

export const AMARON__EVENT_CONTAINER__CALLS_COUNT__COLUMN_ID = "0d6684e2-d14b-4cb1-adc9-8a10de6eca88" as Uuid;

export const AMARON__EVENT_CONTAINER__SERVICE_COUNT__COLUMN_ID = "e54537bb-6619-419d-bebf-b58d39455e95" as Uuid;

export const AMARON__EVENT_CONTAINER__LAST_ACTIVITY__COLUMN_ID = "2cf38928-137d-4767-9d42-0d54b59898ef" as Uuid;

export const AMARON__EVENT_CONTAINER__LAST_ACTIVITY_ON__COLUMN_ID = "bbbbfc2d-d290-4971-98a3-df679178cb59" as Uuid;

export const AMARON__EVENT_CONTAINER__LAST_ENQUIRY_CREATED_AT__COLUMN_ID = "ed5943cf-4f27-4851-bd3d-6f25b7040887" as Uuid;

export const AMARON__EVENT_CONTAINER__CUSTOMER_PLATFORM__COLUMN_ID = "ddb93976-63e3-4304-abaf-52129b2fd8f4" as Uuid;

export const AMARON__EVENT_CONTAINER__ACTION_PLATFORM__COLUMN_ID = "b5c59315-aa57-4433-a17a-3ff7ec738ecf" as Uuid;

export const AMARON__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID = "01e7b7bc-0c8e-4ba6-a177-af96e43d62db" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_PLATFORM__COLUMN_ID = "703d923c-da94-40a7-92e8-f70a4e7408c2" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_SOURCE__COLUMN_ID = "7dcfb5a4-cfa4-43b3-8dbc-a7e28098410f" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_MEDIUM__COLUMN_ID = "28db5d5f-96e4-42c9-a6bf-77e5db94325b" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_CAMPAIGN__COLUMN_ID = "0e4525f1-c181-4856-ac60-006b50219289" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_TERM__COLUMN_ID = "91b3a1d5-9b9c-4316-ae23-03b2fd35cdb2" as Uuid;

export const AMARON__EVENT_CONTAINER__UTM_CONTENT__COLUMN_ID = "50877f72-39cb-45c5-9b85-ca741717ad7a" as Uuid;

export const AMARON__EVENT_CONTAINER__GAD_SOURCE__COLUMN_ID = "a5f02cff-fffa-4a63-81e6-e1592b2b7aa9" as Uuid;

export const AMARON__EVENT_CONTAINER__GAD_CAMPAIGN_ID__COLUMN_ID = "0f1ea0cd-0a85-459e-8cab-e08dbe39f7aa" as Uuid;

export const AMARON__EVENT_CONTAINER__GBRAID__COLUMN_ID = "60281198-3aa4-4d64-bd79-cff941b1affe" as Uuid;

export const AMARON__EVENT_CONTAINER__GCLID__COLUMN_ID = "05c42ad8-8cb0-446a-9a36-41e8ce50b621" as Uuid;

export const AMARON__EVENT_CONTAINER__FAD_SOURCE__COLUMN_ID = "c21cf0bc-bf13-4b8f-adc3-860874580717" as Uuid;

export const AMARON__EVENT_CONTAINER__FAD_CAMPAIGN_ID__COLUMN_ID = "68231d7d-b497-4839-b3a9-efdddd96c2ab" as Uuid;

export const AMARON__EVENT_CONTAINER__FBRAID__COLUMN_ID = "668af499-8493-4302-a882-379317d824ae" as Uuid;

export const AMARON__EVENT_CONTAINER__FBCLID__COLUMN_ID = "88f9133a-f860-4be1-baf4-43bfc3551fbd" as Uuid;

export const AMARON__EVENT_CONTAINER__LAST_EVENT__COLUMN_ID = "b84b79a9-b1e4-421d-a62c-0dc8636325b5" as Uuid;

export const AMARON__EVENT_CONTAINER__LAST_EVENT_TIMESTAMP__COLUMN_ID = "a4dbc237-4f45-429d-ae44-fbc250295d42" as Uuid;

export const AMARON__EVENT_CONTAINER__LINK_NAME__COLUMN_ID = "1ff38fb0-fc97-43d3-8b0a-e21c9f48fea4" as Uuid;

export const AMARON__EVENT_CONTAINER__LINK_ID__COLUMN_ID = "f42327a4-15f2-4667-836e-46ffea0d6992" as Uuid;

export const AMARON__EVENT_CONTAINER__PREFERRED_CALLING_TIME__COLUMN_ID = "c272ceb0-519d-4087-b588-114419c225d1" as Uuid;

export const AMARON__EVENT_CONTAINER__LEAD_CATEGORY__COLUMN_ID = "fb32eff7-b557-4d18-b46b-bb7571134292" as Uuid;

export const AMARON__EVENT_CONTAINER__QUOTED_PRICE__COLUMN_ID = "5e82d993-3334-4e07-9fb4-664ec1f1e1ed" as Uuid;

export const AMARON__EVENT_CONTAINER__SERVICE_UPGRADE_REQUIRED__COLUMN_ID = "f125bf63-e64a-45df-a90b-7a9d359a330c" as Uuid;

export enum AmaronLeadStatusEnum {
    LIVE = "c93262f3-58fc-4d64-9de9-afed9e3fa561",
    CHURNED = "fc2210b8-6738-4514-befc-9be7da2ea1c0",
    CONVERTED = "6700cc92-d7a1-4bf7-a20f-41322863a555",
    ARCHIVED = "1d88fa9d-bbd3-4c28-811d-2a59c48c1814",
}

export enum AmaronInqueueStatusEnum {
    UNASSIGNED = "ea3c8df5-7b19-4f6e-94d1-3d02c6b3d919",
    ASSIGNED = "d482ecba-5e65-40c3-b921-4f1c3f425e74",
}

export enum AmaronFuelTypeEnum {
    PETROL = "71b2ac4d-e8ff-4232-a574-91e5c4b7a081",
    DIESEL = "82c3bd5e-f9aa-4463-a685-b2f6d5c8c192",
    CNG = "93d4ce6f-0abb-4564-b796-c3d7e6f9d2a3",
    ELECTRIC = "a4e5df70-1bcc-4675-88a7-d4e8f7a0e3b4",
    HYBRID = "b5f6e081-2cdd-4786-89b8-e5f9a182f4c5",
}

export enum AmaronServiceRequestedEnum {
    BATTERY_SERVICE = "c6a71792-3dee-4897-a0c9-f628b2930586",
    CAR_CLEANING = "d7b82803-4eff-4918-b1da-0739c3941697",
    CAR_SERVICE = "e8c93914-5111-4929-a2eb-1840d4752788",
    ADVISOR_GUIDANCE_NEEDED = "f9da4a25-6233-493a-b4fc-f951e5863899",
    OTHER = "b8e40a9b-f263-457f-b3a6-4c0839c48519",
}

export enum AmaronPreferredCallingTimeEnum {
    TEN_AM_TO_TWELVE_PM = "ccfd3e56-93a2-4efc-b1de-155727becbeb",
    TWELVE_PM_TO_TWO_PM = "d5f486b8-9110-457c-b8d1-a3ccdeb6f9e9",
    TWO_PM_TO_FOUR_PM = "1b29df30-82cb-4dc1-a78c-29c05442efc1",
    FOUR_PM_TO_SIX_PM = "8e9df691-c223-412a-abe4-3667ada9e9bd",
    SIX_PM_TO_EIGHT_PM = "9ee72dff-c873-403d-8f9d-2921b64e3ddc",
}

export enum AmaronLeadCategoryEnum {
    EMERGENCY = "8b63aa08-14e8-4fce-b62a-e7f93f6151de",
    HOT = "ccadd558-4531-44cf-9642-213241891ade",
    WARM = "3528f0d3-a546-4e64-9f0c-edfed6e7ab15",
    COLD = "29a96708-c6d5-4f73-b1bb-007516199939",
    CLOSED = "17db8eae-d3d9-4f4e-a69c-23ee1876e34b",
    AT_RISK = "8a44fca9-5b02-41dd-a6cd-697b2a988eb0",
}

export enum AmaronServiceUpgradeRequiredEnum {
    YES = "f6e786d0-4520-483b-9243-8cfc91afbc73",
    NO = "3db0f123-f901-4e3c-8c9c-423cba1fca94",
}

export enum AmaronEventContainerDispositionEnum {
    NEW_LEAD,
    NOT_CONNECTED_NR1,
    NOT_CONNECTED_NR2,
    NOT_CONNECTED_NR3,
    NOT_CONNECTED_NR4,
    NOT_CONNECTED_NR5,
    NOT_CONNECTED_NR6,
    CONNECTED_VALID_SHORT_HANG_UP,
    CONNECTED_VALID_TRANSFERRED_TO_VOICEMAIL,
    NOT_CONNECTED_CALL_HUNG_UP,
    NOT_CONNECTED_INVALID,
    CONNECTED_VALID_INTERESTED_FOLLOW_UP,
    CONNECTED_VALID_INTERESTED_NEED_MORE_INFORMATION,
    CONNECTED_VALID_INTERESTED_BOOKED,
    CONNECTED_VALID_INTERESTED_OTHER,
    CONNECTED_VALID_INTERESTED_SLOT_NOT_AVAILABLE,
    CONNECTED_VALID_NOT_INTERESTED_PRICE_ISSUE,
    CONNECTED_VALID_NOT_INTERESTED_SERVICE_NOT_DUE,
    CONNECTED_VALID_NOT_INTERESTED_OEM_PREFERRED,
    CONNECTED_VALID_NOT_INTERESTED_NEW_CAR,
    CONNECTED_VALID_NOT_INTERESTED_NO_REQUIREMENT_SHARED,
    CONNECTED_VALID_NOT_INTERESTED_GENERAL_QUERY,
    CONNECTED_VALID_LANGUAGE_ISSUE,
    CONNECTED_VALID_UNSERVICEABLE_AREA_NOT_COVERED,
    CONNECTED_VALID_UNSERVICEABLE_CAR_NOT_SUPPORTED,
    CONNECTED_VALID_UNSERVICEABLE_IMMEDIATE_SERVICE,
    CONNECTED_VALID_UNSERVICEABLE_RSA_REQUEST,
    CONNECTED_VALID_UNSERVICEABLE_NO_CAR_DETAILS,
    CONNECTED_CALL_BACK_LATER_CBL1,
    CONNECTED_CALL_BACK_LATER_CBL2,
    CONNECTED_CALL_BACK_LATER_CBL3,
    CONNECTED_INVALID_DID_NOT_FILL,
    CONNECTED_INVALID_FILLED_BY_MISTAKE,
    WRONG_NUMBER,
    CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_NOT_REACHING_ON_TIME,
    CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_NUMBER_NOT_SHARED,
    CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_DENIED_FOR_SERVICE,
    CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_GAVE_ALTERNATE_NUMBER,
    CONNECTED_VALID_CUSTOMER_ESCALATION_REFUND_NOT_RECEIVED,
    CONNECTED_VALID_CUSTOMER_ESCALATION_CUSTOMER_WANTS_REFUND,
    CONNECTED_VALID_CUSTOMER_ESCALATION_NOT_SATISFIED_WITH_SERVICES,
    CONNECTED_VALID_CUSTOMER_ESCALATION_NOT_USING_APPROPRIATE_PRODUCT,
    CONNECTED_VALID_CUSTOMER_ESCALATION_USING_DIFFERENT_PRODUCT_THAN_RECOMMENDED,
    CONNECTED_VALID_ALREADY_BOOKED,
    CONNECTED_VALID_JOB_RELATED_QUERY,
}

export type AmaronDispositionLevelKey = "l1" | "l2" | "l3" | "l4";

export type AmaronDispositionLevels = Record<AmaronDispositionLevelKey, string>;

export const amaronLeadStatuses: Record<AmaronLeadStatusEnum, {id: Uuid; displayName: string}> = {
    [AmaronLeadStatusEnum.LIVE]: {
        id: AmaronLeadStatusEnum.LIVE as Uuid,
        displayName: "Live",
    },
    [AmaronLeadStatusEnum.CHURNED]: {
        id: AmaronLeadStatusEnum.CHURNED as Uuid,
        displayName: "Churned",
    },
    [AmaronLeadStatusEnum.CONVERTED]: {
        id: AmaronLeadStatusEnum.CONVERTED as Uuid,
        displayName: "Converted",
    },
    [AmaronLeadStatusEnum.ARCHIVED]: {
        id: AmaronLeadStatusEnum.ARCHIVED as Uuid,
        displayName: "Archived",
    },
};

export const amaronInqueueStatuses: Record<AmaronInqueueStatusEnum, {id: Uuid; displayName: string}> = {
    [AmaronInqueueStatusEnum.UNASSIGNED]: {
        id: AmaronInqueueStatusEnum.UNASSIGNED as Uuid,
        displayName: "Unassigned",
    },
    [AmaronInqueueStatusEnum.ASSIGNED]: {
        id: AmaronInqueueStatusEnum.ASSIGNED as Uuid,
        displayName: "Assigned",
    },
};

export const amaronFuelTypes: Record<AmaronFuelTypeEnum, {id: Uuid; displayName: string}> = {
    [AmaronFuelTypeEnum.PETROL]: {
        id: AmaronFuelTypeEnum.PETROL as Uuid,
        displayName: "Petrol",
    },
    [AmaronFuelTypeEnum.DIESEL]: {
        id: AmaronFuelTypeEnum.DIESEL as Uuid,
        displayName: "Diesel",
    },
    [AmaronFuelTypeEnum.CNG]: {
        id: AmaronFuelTypeEnum.CNG as Uuid,
        displayName: "CNG",
    },
    [AmaronFuelTypeEnum.ELECTRIC]: {
        id: AmaronFuelTypeEnum.ELECTRIC as Uuid,
        displayName: "Electric",
    },
    [AmaronFuelTypeEnum.HYBRID]: {
        id: AmaronFuelTypeEnum.HYBRID as Uuid,
        displayName: "Hybrid",
    },
};

/** Service-product line selections — Journey + Enquiry event select options */
// export enum AmaronServiceRequestedEnum {
//     BATTERY = "c6a71792-3dee-4897-a0c9-f628b2930586",
//     TYRE = "d7b82803-4eff-4918-b1da-0739c3941697",
//     CAR_SERVICE = "e8c93914-5111-4929-a2eb-1840d4752788",
//     OTHER = "f9da4a25-6233-493a-b4fc-f951e5863899",
// }

// export const amaronServiceRequestedTypes: Record<AmaronServiceRequestedEnum, {id: Uuid; displayName: string}> = {
//     [AmaronServiceRequestedEnum.BATTERY]: {
//         id: AmaronServiceRequestedEnum.BATTERY as Uuid,
//         displayName: "Battery",
//     },
//     [AmaronServiceRequestedEnum.TYRE]: {
//         id: AmaronServiceRequestedEnum.TYRE as Uuid,
//         displayName: "Tyre",
//     },
//     [AmaronServiceRequestedEnum.CAR_SERVICE]: {
//         id: AmaronServiceRequestedEnum.CAR_SERVICE as Uuid,
//         displayName: "Car Service",
//     },
//     [AmaronServiceRequestedEnum.OTHER]: {
//         id: AmaronServiceRequestedEnum.OTHER as Uuid,
//         displayName: "Other",
//     },
// };

// Call status enum (Logged, Scheduled, Cancelled, Archive) - archive hides completed rows without cancelling semantics

export const amaronServiceRequestedTypes: Record<AmaronServiceRequestedEnum, {id: Uuid; displayName: string}> = {
    [AmaronServiceRequestedEnum.BATTERY_SERVICE]: {
        id: AmaronServiceRequestedEnum.BATTERY_SERVICE as Uuid,
        displayName: "Battery Service",
    },
    [AmaronServiceRequestedEnum.CAR_CLEANING]: {
        id: AmaronServiceRequestedEnum.CAR_CLEANING as Uuid,
        displayName: "Car Cleaning",
    },
    [AmaronServiceRequestedEnum.CAR_SERVICE]: {
        id: AmaronServiceRequestedEnum.CAR_SERVICE as Uuid,
        displayName: "Car Service",
    },
    [AmaronServiceRequestedEnum.ADVISOR_GUIDANCE_NEEDED]: {
        id: AmaronServiceRequestedEnum.ADVISOR_GUIDANCE_NEEDED as Uuid,
        displayName: "Advisor Guidance needed",
    },
    [AmaronServiceRequestedEnum.OTHER]: {
        id: AmaronServiceRequestedEnum.OTHER as Uuid,
        displayName: "Other",
    },
};

export const amaronPreferredCallingTimes: Record<AmaronPreferredCallingTimeEnum, {id: Uuid; displayName: string}> = {
    [AmaronPreferredCallingTimeEnum.TEN_AM_TO_TWELVE_PM]: {
        id: AmaronPreferredCallingTimeEnum.TEN_AM_TO_TWELVE_PM as Uuid,
        displayName: "10am - 12pm",
    },
    [AmaronPreferredCallingTimeEnum.TWELVE_PM_TO_TWO_PM]: {
        id: AmaronPreferredCallingTimeEnum.TWELVE_PM_TO_TWO_PM as Uuid,
        displayName: "12pm - 2pm",
    },
    [AmaronPreferredCallingTimeEnum.TWO_PM_TO_FOUR_PM]: {
        id: AmaronPreferredCallingTimeEnum.TWO_PM_TO_FOUR_PM as Uuid,
        displayName: "2pm - 4pm",
    },
    [AmaronPreferredCallingTimeEnum.FOUR_PM_TO_SIX_PM]: {
        id: AmaronPreferredCallingTimeEnum.FOUR_PM_TO_SIX_PM as Uuid,
        displayName: "4pm - 6pm",
    },
    [AmaronPreferredCallingTimeEnum.SIX_PM_TO_EIGHT_PM]: {
        id: AmaronPreferredCallingTimeEnum.SIX_PM_TO_EIGHT_PM as Uuid,
        displayName: "6pm - 8pm",
    },
};

export const amaronLeadCategories: Record<AmaronLeadCategoryEnum, {id: Uuid; displayName: string}> = {
    [AmaronLeadCategoryEnum.EMERGENCY]: {
        id: AmaronLeadCategoryEnum.EMERGENCY as Uuid,
        displayName: "Emergency",
    },
    [AmaronLeadCategoryEnum.HOT]: {
        id: AmaronLeadCategoryEnum.HOT as Uuid,
        displayName: "Hot",
    },
    [AmaronLeadCategoryEnum.WARM]: {
        id: AmaronLeadCategoryEnum.WARM as Uuid,
        displayName: "Warm",
    },
    [AmaronLeadCategoryEnum.COLD]: {
        id: AmaronLeadCategoryEnum.COLD as Uuid,
        displayName: "Cold",
    },
    [AmaronLeadCategoryEnum.CLOSED]: {
        id: AmaronLeadCategoryEnum.CLOSED as Uuid,
        displayName: "Closed",
    },
    [AmaronLeadCategoryEnum.AT_RISK]: {
        id: AmaronLeadCategoryEnum.AT_RISK as Uuid,
        displayName: "At risk",
    },
};

export const amaronServiceUpgradeRequiredOptions: Record<AmaronServiceUpgradeRequiredEnum, {id: Uuid; displayName: string}> = {
    [AmaronServiceUpgradeRequiredEnum.YES]: {
        id: AmaronServiceUpgradeRequiredEnum.YES as Uuid,
        displayName: "Yes",
    },
    [AmaronServiceUpgradeRequiredEnum.NO]: {
        id: AmaronServiceUpgradeRequiredEnum.NO as Uuid,
        displayName: "No",
    },
};

/**
 * Journey disposition leaves: {@link amaronEventContainerDispositions} encodes L1–L4 as
 * `flatDisposition` segments separated by underscores (hyphens inside a segment).
 * Default journey disposition is New Lead (system-assigned, not user-selectable). L1 hides `new-lead` when
 * the current disposition is still New Lead ({@link OttopilotDispositionOptionRuleActionKind.hideWhenCurrentDispositionIdEquals})
 * or once history records any change away from New Lead ({@link amaronDispositionConfig}).
 */
export const amaronEventContainerDispositions: Record<AmaronEventContainerDispositionEnum, {id: Uuid; displayName: string; flatDisposition: string}> = {
    [AmaronEventContainerDispositionEnum.NEW_LEAD]: {
        id: "2dff5e32-11e1-4da5-90ca-e61a5b5022a7" as Uuid,
        displayName: "New Lead",
        flatDisposition: "new-lead",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR1]: {
        id: "7b049d5d-774c-43cf-b681-271a2b9279e1" as Uuid,
        displayName: "Not Connected - NR1",
        flatDisposition: "not-connected_nr1",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR2]: {
        id: "e2ac5a34-bdf9-4772-b158-f599c2ae85bd" as Uuid,
        displayName: "Not Connected - NR2",
        flatDisposition: "not-connected_nr2",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR3]: {
        id: "7d3448bf-425f-4bb6-9b00-38f8773eb3e9" as Uuid,
        displayName: "Not Connected - NR3",
        flatDisposition: "not-connected_nr3",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR4]: {
        id: "4a12ed0d-98a1-4b16-baa0-6aad88bee40c" as Uuid,
        displayName: "Not Connected - NR4",
        flatDisposition: "not-connected_nr4",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR5]: {
        id: "55926ad9-6a02-4593-b93e-d1674d2c1a6a" as Uuid,
        displayName: "Not Connected - NR5",
        flatDisposition: "not-connected_nr5",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_NR6]: {
        id: "e7a8a9fa-8fc5-4b4b-ae63-6528a8e078c5" as Uuid,
        displayName: "Not Connected - NR6",
        flatDisposition: "not-connected_nr6",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_SHORT_HANG_UP]: {
        id: "a71ef4f9-bd4f-47e6-a19b-07624261aea3" as Uuid,
        displayName: "Connected - Valid - Short Hang Up",
        flatDisposition: "connected_valid_short-hang-up",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_TRANSFERRED_TO_VOICEMAIL]: {
        id: "d61cf38b-05cf-4f94-af6e-dbd1dba8ae2c" as Uuid,
        displayName: "Connected - Valid - Transferred to Voicemail",
        flatDisposition: "connected_valid_transferred-to-voicemail",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_CALL_HUNG_UP]: {
        id: "e9eb266b-b789-427b-85eb-911816e3e950" as Uuid,
        displayName: "Not Connected - Call Hung Up",
        flatDisposition: "not-connected_call-hung-up",
    },
    [AmaronEventContainerDispositionEnum.NOT_CONNECTED_INVALID]: {
        id: "e8f63e99-1c9e-4d87-bc4b-869722d093a8" as Uuid,
        displayName: "Not Connected - Invalid",
        flatDisposition: "not-connected_invalid",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_FOLLOW_UP]: {
        id: "6cb95f3a-20e5-4f92-8888-9296cb2fb2a1" as Uuid,
        displayName: "Connected - Valid - Interested - Follow Up",
        flatDisposition: "connected_valid_interested_follow-up",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_NEED_MORE_INFORMATION]: {
        id: "a52fb230-a974-49ef-813a-600f512c51f4" as Uuid,
        displayName: "Connected - Valid - Interested - Need More Information",
        flatDisposition: "connected_valid_interested_need-more-information",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_BOOKED]: {
        id: "72372304-ca04-4704-a421-ffa43a91328c" as Uuid,
        displayName: "Connected - Valid - Interested - Booked",
        flatDisposition: "connected_valid_interested_booked",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_OTHER]: {
        id: "97727290-e768-4d4b-885f-d96d24b5b6c3" as Uuid,
        displayName: "Connected - Valid - Interested - Other",
        flatDisposition: "connected_valid_interested_other",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_SLOT_NOT_AVAILABLE]: {
        id: "7f95ab33-42eb-481a-9431-f62c85cb0bb5" as Uuid,
        displayName: "Connected - Valid - Interested - Slot Not Available",
        flatDisposition: "connected_valid_interested_slot-not-available",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_PRICE_ISSUE]: {
        id: "e2fc5392-9ae7-4251-a7a6-2dbf5f93a3a4" as Uuid,
        displayName: "Connected - Valid - Not Interested - Price Issue",
        flatDisposition: "connected_valid_not-interested_price-issue",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_SERVICE_NOT_DUE]: {
        id: "ac45c156-405b-449b-8e95-a9c021ee2df2" as Uuid,
        displayName: "Connected - Valid - Not Interested - Service Not Due",
        flatDisposition: "connected_valid_not-interested_service-not-due",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_OEM_PREFERRED]: {
        id: "1d46f194-bc6d-4e9b-8d27-a61d4a569e15" as Uuid,
        displayName: "Connected - Valid - Not Interested - OEM Preferred",
        flatDisposition: "connected_valid_not-interested_oem-preferred",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_NEW_CAR]: {
        id: "a217cb08-6f34-4463-8296-07775d3cae82" as Uuid,
        displayName: "Connected - Valid - Not Interested - New Car",
        flatDisposition: "connected_valid_not-interested_new-car",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_NO_REQUIREMENT_SHARED]: {
        id: "2f58e07a-cccd-4c56-975f-12fed88d43ae" as Uuid,
        displayName: "Connected - Valid - Not Interested - No Requirement Shared",
        flatDisposition: "connected_valid_not-interested_no-requirement-shared",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_GENERAL_QUERY]: {
        id: "16004021-ad57-42b7-ab20-687ccddd71e3" as Uuid,
        displayName: "Connected - Valid - Not Interested - General Query",
        flatDisposition: "connected_valid_not-interested_general-query",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_LANGUAGE_ISSUE]: {
        id: "f28daee1-ac2a-4554-8d65-53ba8fb5f1b6" as Uuid,
        displayName: "Connected - Valid - Language Issue",
        flatDisposition: "connected_valid_language-issue",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_UNSERVICEABLE_AREA_NOT_COVERED]: {
        id: "6cde2f10-83eb-467f-9aed-037a924dcc0d" as Uuid,
        displayName: "Connected - Valid - Unserviceable - Area Not Covered",
        flatDisposition: "connected_valid_unserviceable_area-not-covered",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_UNSERVICEABLE_CAR_NOT_SUPPORTED]: {
        id: "a1fb72cf-a439-4b5b-ac88-d3c10a28d1d4" as Uuid,
        displayName: "Connected - Valid - Unserviceable - Car Not Supported",
        flatDisposition: "connected_valid_unserviceable_car-not-supported",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_UNSERVICEABLE_IMMEDIATE_SERVICE]: {
        id: "4130f03b-8722-4848-b1ae-a962fba5a470" as Uuid,
        displayName: "Connected - Valid - Unserviceable - Immediate Service",
        flatDisposition: "connected_valid_unserviceable_immediate-service",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_UNSERVICEABLE_RSA_REQUEST]: {
        id: "81827db9-0dbe-4c3d-aa3a-af880c5d19b3" as Uuid,
        displayName: "Connected - Valid - Unserviceable - RSA Request",
        flatDisposition: "connected_valid_unserviceable_rsa-request",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_UNSERVICEABLE_NO_CAR_DETAILS]: {
        id: "e2c81778-678b-47d5-ad7f-ad74ee3c08ea" as Uuid,
        displayName: "Connected - Valid - Unserviceable - No Car Details",
        flatDisposition: "connected_valid_unserviceable_no-car-details",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL1]: {
        id: "9cd9f2cb-98e8-4a65-9c92-fc0f72a32f74" as Uuid,
        displayName: "Connected - Call Back Later - CBL1",
        flatDisposition: "connected_call-back-later_cbl1",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL2]: {
        id: "84eac50e-c68f-4415-b8c3-9082b2c6035f" as Uuid,
        displayName: "Connected - Call Back Later - CBL2",
        flatDisposition: "connected_call-back-later_cbl2",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL3]: {
        id: "e3afb9dc-d3c4-44c9-a587-f5a8bbd54e45" as Uuid,
        displayName: "Connected - Call Back Later - CBL3",
        flatDisposition: "connected_call-back-later_cbl3",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILL]: {
        id: "41929377-5c8e-43a2-a4c1-48057fed382b" as Uuid,
        displayName: "Connected - Invalid - Did Not Fill",
        flatDisposition: "connected_invalid_did-not-fill",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE]: {
        id: "7afa4f16-2350-49e7-b48c-ce8b1f0b8f45" as Uuid,
        displayName: "Connected - Invalid - Filled By Mistake",
        flatDisposition: "connected_invalid_filled-by-mistake",
    },
    [AmaronEventContainerDispositionEnum.WRONG_NUMBER]: {
        id: "be95d238-4dd4-41b5-adaa-e34ca069f4fd" as Uuid,
        displayName: "Wrong Number",
        flatDisposition: "wrong-number",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_NOT_REACHING_ON_TIME]: {
        id: "8057013b-2fdb-47db-8d4d-1cd199a46bfe" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Marshal not reaching on time",
        flatDisposition: "connected_valid_customer-escalation_marshal-not-reaching-on-time",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_NUMBER_NOT_SHARED]: {
        id: "c480ca13-21de-4f9b-b476-0c670b889cfd" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Marshal number not shared",
        flatDisposition: "connected_valid_customer-escalation_marshal-number-not-shared",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_DENIED_FOR_SERVICE]: {
        id: "649a532c-9726-47c5-91f6-c47792bafe04" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Marshal denied for service",
        flatDisposition: "connected_valid_customer-escalation_marshal-denied-for-service",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_MARSHAL_GAVE_ALTERNATE_NUMBER]: {
        id: "618d93be-9485-4c4c-abb4-4896272d5845" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Marshal gave alternate number",
        flatDisposition: "connected_valid_customer-escalation_marshal-gave-alternate-number",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_REFUND_NOT_RECEIVED]: {
        id: "fd5d9bb0-cc31-47f9-8b58-0dd8b372d8f7" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Refund not received",
        flatDisposition: "connected_valid_customer-escalation_refund-not-received",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_CUSTOMER_WANTS_REFUND]: {
        id: "c3bff780-961d-43e4-ac8a-5c99f620f339" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Customer wants refund",
        flatDisposition: "connected_valid_customer-escalation_customer-wants-refund",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_NOT_SATISFIED_WITH_SERVICES]: {
        id: "df1dc880-7e29-42c9-aa5d-870f37ebce27" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Not satisfied with the services",
        flatDisposition: "connected_valid_customer-escalation_not-satisfied-with-the-services",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_NOT_USING_APPROPRIATE_PRODUCT]: {
        id: "9f73ea99-6cb7-40d5-bfa3-132a15e5813b" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Not using the appropriate product",
        flatDisposition: "connected_valid_customer-escalation_not-using-the-appropriate-product",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_CUSTOMER_ESCALATION_USING_DIFFERENT_PRODUCT_THAN_RECOMMENDED]: {
        id: "57f9629a-0cd1-47ed-8199-ffc13dc9ba6e" as Uuid,
        displayName: "Connected - Valid - Customer Escalation - Using a different product than what was recommended",
        flatDisposition: "connected_valid_customer-escalation_using-a-different-product-than-what-was-recommended",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_ALREADY_BOOKED]: {
        id: "b97c26de-c94e-445d-bb66-783c714e0378" as Uuid,
        displayName: "Connected - Valid - Already Booked",
        flatDisposition: "connected_valid_already-booked",
    },
    [AmaronEventContainerDispositionEnum.CONNECTED_VALID_JOB_RELATED_QUERY]: {
        id: "21b6c7a3-23ed-465f-9e4e-1930c0659635" as Uuid,
        displayName: "Connected - Valid - Job Related Query",
        flatDisposition: "connected_valid_job-related-query",
    },
};

/** Human-readable values for in-queue Status filter pickers (not stored UUIDs). */
export function getAmaronInqueueStatusFilterPickerValues(): Array<string> {
    return Object.values(amaronInqueueStatuses).map((status) => status.displayName);
}

/** Stored category UUIDs for Lead Category filter pickers. */
export function getAmaronLeadCategoryFilterPickerValues(): Array<string> {
    return Object.values(amaronLeadCategories).map((category) => String(category.id));
}

export function formatAmaronLeadCategoryFilterValue(value: string): string {
    const trimmed = value.trim();
    if (trimmed === "") {
        return "";
    }
    const matched = Object.values(amaronLeadCategories).find((category) => String(category.id) === trimmed);
    return matched?.displayName ?? trimmed;
}

export function getAmaronEventContainerDispositions(): Array<{id: Uuid; displayName: string}> {
    return Object.values(amaronEventContainerDispositions).map((disposition) => ({
        id: disposition.id,
        displayName: disposition.displayName,
    }));
}
